/*
 * @Description: 公共函数
 */

import Cookies from "js-cookie";
import {
  COOKIE_EXPIRES,
  TOKEN_KEY
} from "@/config"; // cookie保存的天数
import FileSaver from "file-saver";
import XLSX from "xlsx";
import uuid from "uuid";

/**
 * 获取分页数据
 * @param {*} data 数据源
 * @param {*} index 索引
 * @param {*} size 分页大小
 */
export const getPage = function (data, index, size) {
  let startIndex = (index - 1) * size;
  let endIndex = index * size;
  let page = {
    data: data.slice(startIndex, endIndex),
    total: data.length,
    pageIndex: index,
    pageSize: size,
  };
  return page;
};

/**
 * @param {string} url
 * @returns {Object}
 */
export function param2Obj(url) {
  const search = url.split("?")[1];
  if (!search) {
    return {};
  }
  return JSON.parse(
    '{"' +
    decodeURIComponent(search)
    .replace(/"/g, '\\"')
    .replace(/&/g, '","')
    .replace(/=/g, '":"')
    .replace(/\+/g, " ") +
    '"}'
  );
}

/**
 * 计算两时间差的天数
 * @param {*} sDate1
 * @param {*} sDate2
 */
function datedifference(sDate1, sDate2) {
  //sDate1和sDate2是2006-12-18格式
  var dateSpan, tempDate, iDays;
  sDate1 = Date.parse(sDate1);
  sDate2 = Date.parse(sDate2);
  dateSpan = sDate2 - sDate1;
  dateSpan = Math.abs(dateSpan);
  iDays = Math.floor(dateSpan / (24 * 3600 * 1000));
  return iDays;
}

/**
 * @msg: 存取token
 * @param {string} token
 */
export const setToken = (token) => {
  Cookies.set(TOKEN_KEY, token, {
    expires: COOKIE_EXPIRES || 1,
  });
};

export const getToken = () => {
  const token = Cookies.get(TOKEN_KEY);
  if (token) {
    return token;
  } else {
    return false;
  }
};

/**
 * @msg: 存取token
 * @param {string} token
 */
export const setTheme = (value) => {
  Cookies.set("Theme", value, {
    expires: COOKIE_EXPIRES || 1,
  });
};

export const getTheme = () => {
  const value = Cookies.get("Theme");
  if (value) {
    return value;
  } else {
    return "black";
  }
};

/**
 * @param {String} url
 * @description 从URL中解析参数
 */
export const getParams = (url) => {
  const keyValueArr = url.split("?")[1].split("&");
  let paramObj = {};
  keyValueArr.forEach((item) => {
    const keyValue = item.split("=");
    paramObj[keyValue[0]] = keyValue[1];
  });
  return paramObj;
};

/**
 * 判断一个对象是否存在key，如果传入第二个参数key，则是判断这个obj对象是否存在key这个属性
 * 如果没有传入key这个参数，则判断obj对象是否有键值对
 */
export const hasKey = (obj, key) => {
  if (key) {
    return key in obj;
  } else {
    const keysArr = Object.keys(obj);
    return keysArr.length;
  }
};

/**
 * @msg: 获取系统当前时间
 * @param {string} fmt 时间格式 具体看代码
 * @return: string
 */
export const getDate = (fmt) => {
  let time = "";
  const date = new Date();
  const o = {
    "M+": date.getMonth() + 1, // 月份
    "d+": date.getDate(), // 日
    "H+": date.getHours(), // 小时
    "m+": date.getMinutes(), // 分
    "s+": date.getSeconds(), // 秒
    "q+": Math.floor((date.getMonth() + 3) / 3), // 季度
    S: date.getMilliseconds(), // 毫秒
  };
  if (/(y+)/.test(fmt)) {
    time = fmt.replace(
      RegExp.$1,
      (date.getFullYear() + "").substr(4 - RegExp.$1.length)
    );
  }
  for (const k in o) {
    if (new RegExp("(" + k + ")").test(fmt)) {
      time = fmt.replace(
        RegExp.$1,
        RegExp.$1.length === 1 ? o[k] : ("00" + o[k]).substr(("" + o[k]).length)
      );
    }
  }
  return time;
};

/**
 * @msg: 获取该月有多少天
 * @param {year} year
 * @param {month} month
 */
export function getDaysInOneMonth(year, month) {
  month = parseInt(month, 10);
  let d = new Date(year, month, 0);
  return d.getDate();
}

/**
 *
 * @param {*} 获取x轴
 *
 */

/**
 * @msg：根据时间类型获取动态的年月周日的x周
 * @param {*}： timeData传入的数据 ，index索引，1是时，2是日，3是周，4是月，5是年
 */
export function getX(timeData1, index, ismonth) {
  let mee = []; //月
  let yee = []; //年
  let wee = []; //周
  let dee = []; //日
  let hee = []; //时
  let arr = [];
  let timeData = JSON.parse(JSON.stringify(timeData1));
  let timee;
  if (index == 5) {
    for (let i = 0; i < timeData.length; i++) {
      timee = Date.parse(timeData[i].time) / 1000;
      yee.push(formatTime(timee, "Y"));
      arr.push(formatTime(timee, "Y"));
    }
    // arr=arr.concat(yee)
    for (let i = 0; i < yee.length; i++) {
      timeData[i].time = yee[i];
    }
  } else if (index == 4) {
    for (let i = 0; i < timeData.length; i++) {
      timee = Date.parse(timeData[i].time) / 1000;
      mee.push(formatTime(timee, "Y-M-D"));
      arr.push(formatTime(timee, "M"));
      //   timeData.push(formatTime(timee, "M"));
    }
    // arr = arr.concat(mee);
    if (ismonth == true) {
      for (let i = 0; i < arr.length; i++) {
        switch (arr[i]) {
          case "01":
            // mee[i].month = "Jan";
            timeData[i].time = "Jan";
            break;
          case "02":
            // mee[i].month = "Feb";
            timeData[i].time = "Feb";
            break;
          case "03":
            // mee[i].month = "Mar";
            timeData[i].time = "Mar";
            break;
          case "04":
            // mee[i].month = "Apr";
            timeData[i].time = "Apr";
            break;
          case "05":
            // mee[i].month = "May";
            timeData[i].time = "May";
            break;
          case "06":
            // mee[i].month = "Jun";
            timeData[i].time = "Jun";
            break;
          case "07":
            // mee[i].month = "Jul";
            timeData[i].time = "Jul";
            break;
          case "08":
            // mee[i].month = "Aug";
            timeData[i].time = "Aug";
            break;
          case "09":
            // mee[i].month = "Sep";
            timeData[i].time = "Sep";
            break;
          case "10":
            // mee[i].month = "Oct";
            timeData[i].time = "Oct";
            break;
          case "11":
            // mee[i].month = "Nov";
            timeData[i].time = "Nov";
            break;
          case "12":
            // mee[i].month = "Dec";
            timeData[i].time = "Dec";
            break;
        }

        // timeData[i].time = mee[i];
      }
    } else {
      for (let i = 0; i < arr.length; i++) {
        timeData[i].time = mee[i];
      }
    }
  } else if (index == 3) {
    // let ww = getWeekOfYear();
    for (let j = 0; j < timeData.length; j++) {
      wee.push('w' + getWeekOfYear(timeData[j].time));
      timeData[j].time = 'w' + getWeekOfYear(timeData[j].time);
    }
    timeData = (addWeek(timeData))
  } else if (index == 2) {
    for (let i = 0; i < timeData.length; i++) {
      timee = Date.parse(timeData[i].time) / 1000;
      dee.push(formatTime(timee, "M.D"));
    }
    for (let i = 0; i < dee.length; i++) {
      timeData[i].time = dee[i];
      for (let i = 0; i < dee.length; i++) {
        timeData[i].time = dee[i];
      }
    }
  } else if (index == 1) {
    for (let i = 0; i < timeData.length; i++) {
      timee = Date.parse(timeData[i].time) / 1000;
      hee.push(formatTime(timee, "h") + "时");
    }
    arr = arr.concat(hee);
    for (let i = 0; i < hee.length; i++) {
      timeData[i].time = hee[i];
    }
  }
  //   return addWeek(timeData) ;
  return timeData;

}

/**
 * @params{*}  截取两位字符串
 */
export function getSlice(data) {
  for (let i = 0; i < data.length; i++) {
    // if (data[i] >= 0 && data[i] !== "") {
    //   data[i] = parseFloat(data[i]).toFixed(2);
    // }
    if (data[i] !== "") {
      data[i] = parseFloat(data[i]).toFixed(2);
    }
  }
  return data;
}
/**
 * @params{*}  相同周累计
 * @weekData  //传入的周数据
 */
export function addWeek(weekData) {
  let data = JSON.parse(JSON.stringify(weekData))
  let result = {}
  for (let j = 0; j < data.length; j++) {
    if (result[data[j].time]) {
      result[data[j].time] += data[j].value;
    } else {
      result[data[j].time] = data[j].value;
    }
  }
  var keyvalue = [];
  for (var key in result) {
    keyvalue.push({
      time: key,
      value: result[key]
    })
  }
  return keyvalue
}
/**
 * @msg:获取当前是第几周
 * @curTime  传入的时间
 * @param {*}
 */
export function getWeekOfYear(curTime) {
  var today = new Date(curTime);
  var firstDay = new Date(today.getFullYear(), 0, 1);
  var dayOfWeek = firstDay.getDay();
  var spendDay = 1;
  if (dayOfWeek != 0) {
    // spendDay = 7 - dayOfWeek + 1;
    spendDay = 7 - dayOfWeek;
  }
  firstDay = new Date(today.getFullYear(), 0, 1 + spendDay);
  var d = Math.ceil((today.valueOf() - firstDay.valueOf()) / 86400000);
  var result = Math.ceil(d / 7);
  return result + 1;
}
/**
 * @msg: 获取今日数据时间和昨日数据
 *
 * @paramd {number} dataType 0日，1月，2年
 * @return: string 数组，0是今的开始时间，1是今的结束时间，2是昨的开始时间，3是昨的结束时间
 */
export function getTime(dataType) {
  let time = [];
  let y = getDate("yyyy");
  let m = getDate("MM");
  let d = getDate("dd");
  let h = getDate("HH");
  if (dataType == 0) {
    let sd = parseFloat(d) - 1;
    if (m == 1 || m == 3 || m == 5 || m == 7 || m == 8 || m == 10 || m == 12) {
      if (d == 1) {
        sd = 31;
      } else {
        sd = parseFloat(d) - 1;
        if (sd < 10) {
          sd = "0" + sd;
        }
      }
    } else {
      if (d == 1) {
        d = 30;
      } else {
        sd = parseFloat(d) - 1;
        if (sd < 10) {
          sd = "0" + sd;
        }
      }
    }
    time = [
      y + "-" + m + "-" + d + " " + "00:00:00",
      y + "-" + m + "-" + d + " " + "23:59:59",
      y + "-" + m + "-" + sd + " " + "00:00:00",
      y + "-" + m + "-" + sd + " " + "23:59:59",
    ];
  } else if (dataType == 1) {
    let sm = parseFloat(m) - 1;
    if (m == 1) {
      sm = 12;
    } else {
      sm = parseFloat(m) - 1;
    }
    time = [
      y + "-" + m + "-" + d,
      y + "-" + m + "-" + d,
      y + "-" + sm + "-" + d,
      y + "-" + sm + "-" + d,
    ];
  } else {
    let sy = parseFloat(y) - 1;
    time = [y + "-" + m, y + "-" + m, sy + "-" + m, sy + "-" + m];
  }
  return time;
}
/**
 *
 * @param {string} data 上周的第一天，最后一天   月份,时间
 * @return arr 数组 第一个是第一天，最后一个是最后一天
 */
export function getLastWeek(begin, end, month, date) {
  let months = month + 1;
  let time = [];
  if (end < 7 && end > 0) {
    if (
      (month + 1 == 1 && month + 1 == 3) ||
      month + 1 == 5 ||
      month + 1 == 7 ||
      month + 1 == 8 ||
      month + 1 == 10 ||
      month + 1 == 12
    ) {
      begin = 31 + begin;
      if (begin < 10) {
        begin = "0" + begin;
      }
      if (end < 10) {
        end = "0" + end;
      }
      if (month < 10) {
        month = "0" + month;
      }
      if (months < 10) {
        months = "0" + months;
      }
      let begin1 = date.getFullYear() + "-" + month + "-" + begin + " 00:00:00";
      let end1 = date.getFullYear() + "-" + months + "-" + end + " 23:59:59";
      time.push(begin1);
      time.push(end1);
      time.push(begin);
    } else if (month + 1 == 2) {
      begin = 28 + begin;
      if (begin < 10) {
        begin = "0" + begin;
      }
      if (end < 10) {
        end = "0" + end;
      }
      if (month < 10) {
        month = "0" + month;
      }
      if (months < 10) {
        months = "0" + months;
      }
      let begin1 = date.getFullYear() + "-" + month + "-" + begin + " 00:00:00";
      let end1 = date.getFullYear() + "-" + months + "-" + end + " 23:59:59";
      time.push(begin1);
      time.push(end1);
      time.push(begin);
    } else {
      begin = 30 + begin;
      if (begin < 10) {
        begin = "0" + begin;
      }
      if (end < 10) {
        end = "0" + end;
      }
      if (month < 10) {
        month = "0" + month;
      }
      if (months < 10) {
        months = "0" + months;
      }
      let begin1 = date.getFullYear() + "-" + month + "-" + begin + " 00:00:00";
      let end1 = date.getFullYear() + "-" + months + "-" + end + " 23:59:59";
      time.push(begin1);
      time.push(end1);
      time.push(begin);
    }
  } else {
    if (
      (month + 1 == 1 && month + 1 == 3) ||
      month + 1 == 5 ||
      month + 1 == 7 ||
      month + 1 == 8 ||
      month + 1 == 10 ||
      month + 1 == 12
    ) {
      if (begin < 10) {
        begin = "0" + begin;
      }
      if (end < 10) {
        end = "0" + end;
      }
      if (month < 10) {
        month = "0" + month;
      }
      let begin1 = date.getFullYear() + "-" + month + "-" + begin + " 00:00:00";
      let end1 = date.getFullYear() + "-" + month + "-" + end + " 23:59:59";
      time.push(begin1);
      time.push(end1);
      time.push(begin);
    } else if (month + 1 == 2) {
      if (begin < 10) {
        begin = "0" + begin;
      }
      if (end < 10) {
        end = "0" + end;
      }
      if (month < 10) {
        month = "0" + month;
      }
      let begin1 = date.getFullYear() + "-" + month + "-" + begin + " 00:00:00";
      let end1 = date.getFullYear() + "-" + month + "-" + end + " 23:59:59";
      time.push(begin1);
      time.push(end1);
      time.push(begin);
    } else {
      if (begin < 10) {
        begin = "0" + begin;
      }
      if (end < 10) {
        end = "0" + end;
      }
      if (month < 10) {
        month = "0" + month;
      }
      let begin1 = date.getFullYear() + "-" + month + "-" + begin + " 00:00:00";
      let end1 = date.getFullYear() + "-" + month + "-" + end + " 23:59:59";
      time.push(begin1);
      time.push(end1);
      time.push(begin);
    }
  }
  return time;
}
/* @msg: 获取能源看板的数据
 *
 * @paramd {number} dataType 0日，1周，2月，3年
 * @return: string 数组，[1][0]0是本周的第一天。[1][1]1是本周的最后一天。[1][2]2是本周的第一天，[1][3]是上周的最后一天，。以此类推
 * [0][0]0是日的当前开始，[0][1]是日前六天
 * [2][0]是月的当前月，[2][1]是月的前四月
 * [3][0]是年的当前年，[3][1]是年的前年
 */
export function getNykbTime(dataType) {
  let time = [];
  let y = getDate("yyyy");
  let m = getDate("MM");
  let d = getDate("dd");
  let h = getDate("HH");
  let sd = parseFloat(d) - 5;
  let sm = parseFloat(m) - 4;
  if (dataType == 0) {
    if (m == 1 || m == 3 || m == 5 || m == 7 || m == 8 || m == 10 || m == 12) {
      if (d == 1) {
        sd = 31;
      } else {
        sd = parseFloat(d) - 6;
      }
    } else if (m == 2) {
      if (d == 1) {
        sd = 28;
      } else {
        sd = parseFloat(d) - 6;
      }
    } else {
      if (d == 1) {
        sd = 30;
      } else {
        sd = parseFloat(d) - 6;
      }
    }
    if (m < 10) {
      m = "0" + m;
    }
    // if (d < 10) {
    //   d = '0' + d
    // }
    if (sd < 10) {
      sd = "0" + sd;
    }
    time = [
      y + "-" + m + "-" + d + " " + "00:00:00",
      y + "-" + m + "-" + d + " " + "23:59:59",
      y + "-" + m + "-" + sd + " " + "00:00:00",
      y + "-" + m + "-" + sd + " " + "23:59:59",
    ];
  } else if (dataType == 1) {
    let time = [];
    let date = new Date();
    let month = date.getMonth() + 1;
    let lastWeekS = date.getDate() - 7 - 6;
    let lastWeekE = lastWeekS + 6;
    let lastWeekS1 = lastWeekS - 7;
    let lastWeekE1 = lastWeekS1 + 6;
    let week;
    let lweek;
    let lastWeekS2 = lastWeekS1 - 7;
    let lastWeekE2 = lastWeekS2 + 6;
    if (lastWeekE2 < 7 && lastWeekE2 > 0) {
      month = month - 1;
      let a = getLastWeek(lastWeekS2, lastWeekE2, month, date); //上三周
      time.push(a[0]);
      time.push(a[1]);
      week = a[2] - 7;
      lweek = week + 6;
    } else {
      let b = getLastWeek(lastWeekS2, lastWeekE2, month, date); //上三周周
      time.push(b[0]);
      time.push(b[1]);
    }
    if (lweek < 7 && lweek > 0) {
      month = month - 1;
      let aa = getLastWeek(week, lweek, month, date); //上四周
      time.push(aa[0]);
      time.push(aa[1]);
    } else {
      let bb = getLastWeek(week, lweek, month, date); //上四周
      time.push(bb[0]);
      time.push(bb[1]);
    }
    if (month < 10) {
      month = "0" + month;
    }
    if (lastWeekS < 10) {
      lastWeekS = "0" + lastWeekS;
    }
    if (lastWeekE < 10) {
      lastWeekE = "0" + lastWeekE;
    }
    if (lastWeekS1 < 10) {
      lastWeekS1 = "0" + lastWeekS1;
    }
    if (lastWeekE1 < 10) {
      lastWeekE1 = "0" + lastWeekE1;
    }
    date.setDate(date.getDate() - date.getDay() + 1);
    let begin =
      date.getFullYear() + "-" + month + "-" + date.getDate() + " 00:00:00"; //本周第一天
    date.setDate(date.getDate() + 6);
    let end =
      date.getFullYear() + "-" + month + "-" + date.getDate() + " 23:59:59"; //本周最后一天

    let begin1 =
      date.getFullYear() + "-" + month + "-" + lastWeekS + " 00:00:00"; //上一周第一天
    let end1 = date.getFullYear() + "-" + month + "-" + lastWeekE + " 23:59:59"; //上一周最后一天

    let begin2 =
      date.getFullYear() + "-" + month + "-" + lastWeekS1 + " 00:00:00"; //上两周第一天
    let end2 =
      date.getFullYear() + "-" + month + "-" + lastWeekE1 + " 23:59:59"; //上两周最后一天
    time.push(begin);
    time.push(end);
    time.push(begin1);
    time.push(end1);
    time.push(begin2);
    time.push(end2);

    return time;
  } else if (dataType == 2) {
    if (m == 1) {
      sm = "09";
      d = "01";
      sd = 31;
      m = "01";
      time = [
        y + "-" + sm + "-" + d + " " + "00:00:00",
        y + "-" + m + "-" + sd + " " + "23:59:59",
      ];
    } else if (m == 3 || m == 5 || m == 7 || m == 8 || m == 10 || m == 12) {
      sd = 31;
      d = "01";
      sm = parseFloat(m) - 4;
      if (sm < 10) {
        sm = "0" + sm;
      }
      time = [
        y + "-" + sm + "-" + d + " " + "00:00:00",
        y + "-" + m + "-" + sd + " " + "23:59:59",
      ];
    } else if (m == 2) {
      sd = 28;
      d = "01";
      sm = "10";
      time = [
        y + "-" + sm + "-" + d + " " + "00:00:00",
        y + "-" + m + "-" + sd + " " + "23:59:59",
      ];
    } else {
      d = "01";
      sd = 30;
      sm = parseFloat(m) - 4;
      if (sm < 10) {
        sm = "0" + sm;
      }
      time = [
        y + "-" + sm + "-" + d + " " + "00:00:00",
        y + "-" + m + "-" + sd + " " + "23:59:59",
      ];
    }
    // time=[y+"-"+m+"-"+d,y+"-"+m+"-"+d,y+"-"+sm+"-"+d,y+"-"+sm+"-"+d]
  } else {
    let sy = parseFloat(y) - 1;
    d = "01";
    sd = "31";
    m = "01";
    sm = "12";
    time = [
      sy + "-" + m + "-" + d + " " + "00:00:00",
      y + "-" + sm + "-" + sd + " " + "23:59:59",
    ];
  }
  return time;
}
/**
 * @msg: 获取系统当前时间
 * @param {string} date 时间
 * @param {string} fmt 时间格式
 * @return: string
 */
export const formatDate = (date, fmt) => {
  //因为ie11 不支持new Date('2020-10-11 00:00:00')所以先转化成 2020/10/11 00:00:00
  if (typeof (date) == "string") {
    let newStart = date.replace(/-/g, "/")
    date = newStart;

  }
  date = date || new Date();
  fmt = fmt || "yyyy-MM-dd hh:mm:ss";
  let newPattern = fmt.replace(/-/g, "/")
  fmt = newPattern;
  if (Object.prototype.toString.call(date).slice(8, -1) !== "Date") {
    date = new Date(date);
  }
  if (/(y+)/.test(fmt)) {
    fmt = fmt.replace(
      RegExp.$1,
      (date.getFullYear() + "").substr(4 - RegExp.$1.length)
    );
  }
  let o = {
    "M+": date.getMonth() + 1,
    "d+": date.getDate(),
    "h+": date.getHours(),
    "m+": date.getMinutes(),
    "s+": date.getSeconds(),
  };
  for (let k in o) {
    if (new RegExp(`(${k})`).test(fmt)) {
      let str = o[k] + "";
      fmt = fmt.replace(
        RegExp.$1,
        RegExp.$1.length === 1 ? str : padLeftZero(str)
      );
    }
  }
  return fmt;
};

function padLeftZero(str) {
  return ("00" + str).substr(str.length);
}
/**
 * 以“天”为单位获取响应的时间戳
 * @param {*} num
 * 2 个小时之前的时间 -> setDate(-.5)
 * 24 个小时之前的时间 -> setDate(-1)
 * 三天后的时间 -> setDate(3)
 */
export function setDate(num) {
  return Date.now() + num * 24 * 60 * 60 * 1000;
}

// copy in the 'fx-fuli' utils
/**
 * 校验手机号是否正确
 * @param phone 手机号
 */

export const verifyPhone = (phone) => {
  const reg = /^1[34578][0-9]{9}$/;
  const _phone = phone.toString().trim();
  let toastStr =
    _phone === "" ?
    "手机号不能为空~" :
    !reg.test(_phone) && "请输入正确手机号~";
  return {
    errMsg: toastStr,
    done: !toastStr,
    value: _phone,
  };
};

export const verifyStr = (str, text) => {
  const _str = str.toString().trim();
  const toastStr = _str.length ? false : `请填写${text}～`;
  return {
    errMsg: toastStr,
    done: !toastStr,
    value: _str,
  };
};

// 截取字符串
export const sliceStr = (str, sliceLen) => {
  if (!str) {
    return "";
  }
  let realLength = 0;
  const len = str.length;
  let charCode = -1;
  for (let i = 0; i < len; i++) {
    charCode = str.charCodeAt(i);
    if (charCode >= 0 && charCode <= 128) {
      realLength += 1;
    } else {
      realLength += 2;
    }
    if (realLength > sliceLen) {
      return `${str.slice(0, i)}...`;
    }
  }

  return str;
};
/**
 * 时间戳转化为年 月 日 时 分 秒
 * number: 传入时间戳
 * format：返回格式，支持自定义，但参数必须与formateArr里保持一致
 * formatTime(sjc,'Y-M-D h:m:s'));//转换为日期：2017-03-03 03:03:03
 * formatTime(sjc, 'h:m'));//转换为日期：03:03
 */
export function formatTime(number, format) {
  var formateArr = ["Y", "M", "D", "h", "m", "s"];
  var returnArr = [];

  var date = new Date(number * 1000);
  returnArr.push(date.getFullYear());
  returnArr.push(formatNumber(date.getMonth() + 1));
  returnArr.push(formatNumber(date.getDate()));
  returnArr.push(formatNumber(date.getHours()));
  returnArr.push(formatNumber(date.getMinutes()));
  returnArr.push(formatNumber(date.getSeconds()));

  for (var i in returnArr) {
    format = format.replace(formateArr[i], returnArr[i]);
  }
  return format;
}

//数据转化
function formatNumber(n) {
  n = n.toString();
  return n[1] ? n : "0" + n;
}

/**
 * JSON 克隆
 * @param {Object | Json} jsonObj json对象
 * @return {Object | Json} 新的json对象
 */
export function objClone(jsonObj) {
  let buf;
  if (jsonObj instanceof Array) {
    buf = [];
    let i = jsonObj.length;
    while (i--) {
      buf[i] = objClone(jsonObj[i]);
    }
    return buf;
  } else if (jsonObj instanceof Object) {
    buf = {};
    for (let k in jsonObj) {
      buf[k] = objClone(jsonObj[k]);
    }
    return buf;
  } else {
    return jsonObj;
  }
}

/**
 * 数组转树结构数据
 * @param {*} data
 * @param {*} pId
 * @param {*} isReturn //是否是投退分析的界面专用
 */
let index = 1;
export function creatTreeData(data, pId, isReturn) {
  let arr = [];
  if (isReturn) {
    for (var j in data) {
      if (data[j].parentId == pId) {
        let item = {};
        item.id = data[j].id;
        item.disabled = data[j].measureId == "-1";
        item.parentId = data[j].parentId;
        item.label = data[j].measureName;
        item.index = index;
        index++;
        item.children = creatTreeData(data, data[j].id, true);
        arr.push(item);
      }
    }
  } else {
    for (var i in data) {
      if (data[i].parentId == pId) {
        let item = {};
        item.pid = data[i].id;
        item.id = data[i].measureId;
        item.disabled = data[i].measureId == "-1";
        item.parentId = data[i].parentId;
        item.label = data[i].measureName;
        item.index = index;
        index++;
        item.children = creatTreeData(data, data[i].id);
        arr.push(item);
      }
    }
  }
  return arr;
}

function findEffectiveTreeNodeSignal(data) {
  for (let i = 0; i < data.children.length; i++) {
    if (data.children[i].id != -1) return data.children[i];

    let p = findEffectiveTreeNodeSignal(data.children[i]);
    if (p) {
      return p;
    }
  }

  return null;
}

function findEffectiveTreeNodeAll(data) {
  let ret = [];
  ret.push(data);
  for (let i = 0; i < data.children.length; i++) {
    ret.concat(findEffectiveTreeNodeAll(data.children[i]));
  }
  return ret;
}

/**
 * 获取树节点id 不为 -1
 * @param {*} data
 * @param {*} isAll  是否全部
 * @returns isAll为是的时候返回的是数组，为false 返回的是对象
 */
export function findEffectiveTreeNode(data, isAll) {
  if (isAll) {
    let ret = [];
    for (let i = 0; i < data.length; i++)
      ret.concat(findEffectiveTreeNodeAll(data[i]));
    return ret;
  } else {
    for (let i = 0; i < data.length; i++) {
      if (data[i].id != -1) {
        return data[i];
      }
      let p = findEffectiveTreeNodeSignal(data[i]);
      if (p != null) {
        return p;
      }
    }
    return null;
  }
}

/**
 * 不改字段名称
 * @param {*} data
 * @param {*} pId
 */
export function creatArentTreeData(data, pId) {
  let arr = [];
  data.forEach((val, index) => {
    if (val.parentId == pId) {
      let item = {};
      item = val;
      item.children = creatArentTreeData(data, item.id);
      arr.push(item);
    }
  });
  return arr;
}

/**
 * 数组转树结构数据
 * @param {*} data
 * @param {*} pId
 * @param {*} setSort 设置层级
 * @param {*} lastSort 上一级的层级
 */
export function arrToTreeData(data, pId, setSort, lastSort) {
  let arr = [];
  for (var i in data) {
    if (data[i].parentId == pId) {
      let item = data[i];
      item.sort = 0;
      if (setSort == true) {
        item.sort = lastSort + 1;
      }
      item.children = arrToTreeData(data, data[i].id, setSort, item.sort);
      arr.push(item);
    }
  }
  return arr;
}

/**
 * 数组转树结构数据  //表格树专用
 * @param {*} data
 * @param {*} pId
 * @param {*} setSort 设置层级
 * @param {*} lastSort 上一级的层级
 */
export function arrToTreeDataLh(data, pId, setSort, lastSort) {
  let arr = [];
  for (var i in data) {
    if (data[i].parentId == pId) {
      let item = data[i];
      item.sort = 0;
      if (setSort == true) {
        item.sort = lastSort + 1;
      }
      item.children = arrToTreeDataLh(data, data[i].pid, setSort, item.sort);
      item.label =
        item.children.length > 0 ? "|-- " + item.label : "  |-- " + item.label;
      arr.push(item);
    }
  }
  return arr;
}

/**
 * 根据状态转换时间
 * @param {*} type
 */
export function dateToColumns(type, startDate, endDate, align) {
  let arr = [];
  if (typeof (startDate) == "string") {
    let newStart = startDate
    startDate = newStart;
  }
  if (typeof (endDate) == "string") {
    let newEnd = endDate
    endDate = newEnd;
  }
  switch (type) {
    //转成小时
    case "0":
      for (var i = 0; i < 24; i++) {
        let item = {
          //为什么要写+""，因为表格的类型是str
          prop: i + "",
          label: i + "时",
          width: 110,
          show: true,
          align: align ? align : "center",
        };
        arr.push(item);
      }
      break;
    case "2":
    case "3":
      let arrDate = getDuration("day", startDate, endDate);
      for (let i = 0; i < arrDate.length - 1; i++) {
        let item = {
          prop: arrDate[i].toLocaleDateString(),
          label: formatDate(arrDate[i], "MM/dd"),
          show: true,
          width: 150,
          align: align ? align : "center",
        };
        arr.push(item);
      }
      break;
    case "5":
      for (var i = 1; i <= 12; i++) {
        let item = {
          prop: i + "",
          label: i + "月",
          show: true,
          width: 150,
          align: align ? align : "center",
        };
        arr.push(item);
      }
      break;
  }
  return arr;
}

function getDuration(type, start, stop) {
  var $array = new Array();
  var current = new Date(start);
  stop = new Date(stop);
  while (current <= stop) {
    $array.push(new Date(current));
    if (type == "hour") {
      //小时
      current.setHours(current.getHours() + 1);
    } else if (type == "day") {
      //天
      current.setDate(current.getDate() + 1);
    } else if (type == "week") {
      //周
      current.setDate(current.getDate() + 7);
    } else if (type == "month") {
      //月
      current.setMonth(current.getMonth() + 1);
    } else {
      //默认天
      current.setDate(current.getDate() + 1);
    }
  }
  return $array;
}

/**
 * 获取对象中第一个属性
 * @param {*} data
 */
export function get_object_first_attribute(data) {
  for (var key in data) return data[key];
}

/**
 * 数组去重
 * @param {*} arr
 */
export function unique(arr) {
  let result = [];
  let obj = {};
  for (var i = 0; i < arr.length; i++) {
    if (!obj[arr[i].code]) {
      result.push(arr[i]);
      obj[arr[i].code] = true;
    }
  }
  return result;
}
/**
 * 生成分页的参数
 * @param {*} arr
 * @param {*} index
 * @param {*} size
 */
export function toPage(arr, index, size) {
  let start = 0;
  if (index != 1) start = (index - 1) * size;
  let end = index * size;
  return {
    pageIndex: index,
    pageSize: size,
    total: arr.length,
    arr: arr.slice(start, end),
  };
}

/**
 * 根据表格dom id导出excel
 * @param {*} id  表格id
 * @param {*} name  excel文件名称
 * @param {*} isAddTime 是否显示导出时间，或者具体导出时间
 */
export function exportExcel(id, name, isAddTime) {
  if (typeof isAddTime == "boolean") {
    name += formatDate(new Date(), "yyyy年MM月dd日");
  } else if (typeof isAddTime == "string") {
    name += formatDate(new Date(isAddTime), "yyyy年MM月dd日");
  }
  let fix = document.querySelector(".el-table__fixed");
  let wb;
  var xlsxParam = {
    raw: true,
  }; //转换成excel时，使用原始的格式
  if (fix) {
    //判断要导出的节点中是否有fixed的表格，如果有，转换excel时先将该dom移除，然后append回去
    wb = XLSX.utils.table_to_book(
      document.querySelector("#" + id).removeChild(fix),
      xlsxParam
    );
    document.querySelector("#" + id).appendChild(fix);
  } else {
    wb = XLSX.utils.table_to_book(document.querySelector("#" + id), xlsxParam);
  }
  var wbout = XLSX.write(wb, {
    bookType: "xlsx",
    bookSST: true,
    type: "array",
  });
  try {
    FileSaver.saveAs(
      new Blob([wbout], {
        type: "application/octet-stream",
      }),
      name + ".xlsx"
    );
  } catch (e) {
    if (typeof console !== "undefined") console.log(e, wbout);
  }
  return wbout;
}

/**
 * 在数组中根据名称查找内容
 * @param {*} paramName  参数名称
 * @param {*} isJson 是否json类型
 */
export function findDataByParam(paramName, isJson, data) {
  let obj = data.find((obj) => {
    return obj.param == paramName;
  });
  if (obj) {
    if (isJson == false) {
      if (obj.value) {
        return obj.value.replace(/(\s*$)/g, "");
      } else {
        return "";
      }
    } else {
      return JSON.parse(obj.value);
    }
  } else {
    return "";
  }
}

/**
 * 生成菜单树数据
 * @param {*} data  数据
 * @param {*} fid
 */
export function creatMenuJson(data, fid) {
  let arr = [];
  for (let i = 0; i < data.length; i++) {
    if (data[i].parentId == fid) {
      let item = {};
      item = data[i];
      item.children = creatMenuJson(data, data[i].id);
      if (item.children.length > 0) {
        item.component = fid == 0 ? "Layout" : "none";
      }
      arr.push(item);
    }
  }
  return arr;
}
/**
 * 字符串转树
 * @param {*} str
 * @param {*} path
 * @param {*} char  间隔符
 */
export function strToTreeData(str, path, pageId, char, rowitem) {
  let arr = [];
  let strArr = str.split(char);
  let label = strArr[0];
  strArr.splice(0, 1);
  arr.push({
    id: uuid.v4(),
    label: strArr.length == 0 ? label + "(" + path + ")" : label,
    name: label,
    pageId: strArr.length == 0 ? pageId : "",
    // orderNum:rowitem.orderNum,
    // isSystemIcon:rowitem.isSystemIcon,
    // iconResourceId:rowitem.isSystemIcon,
    orderNum: "",
    isSystemIcon: "",
    iconResourceId: "",
    children: strArr.length == 0 ? [] : strToTreeData(strArr.join(char), path, pageId, char, rowitem),
  });
  return arr;
}
/**
 * 合并树结构
 * @param {*} data  数据
 * @param {*} data2
 */
export function mergeTreeData(data, data2) {
  if (data.length == 0) return data2;
  if (data2.length == 0) return data;
  const itemIndex = data.findIndex((obj) => obj.name == data2[0].name);
  if (itemIndex > -1) {
    data[itemIndex].children = mergeTreeData(
      data[itemIndex].children,
      data2[0].children
    );
  } else {
    data = data.concat(data2);
  }
  return data;
}

export function removeNode(root, path, index) {
  for (let i = 0; i < root.length; i++) {
    if (root[i].name == path[index]) {
      if (index + 1 == path.length) {
        root.splice(i, 1);
        return;
      }
      removeNode(root[i].children, path, index + 1);
    }
  }
}

/**
 * 删除某一项
 * @param {*} arr 树数组数据
 * @param {*} value 内容
 * @param {*} type 字段名称
 */
export function removeNodeToItem(arr, value, type) {
  for (var i = 0; i < arr.length; i++) {
    var el = arr[i];
    if (el[type] === value) {
      arr.splice(i, 1);
    } else {
      if (el.children && el.children.length) {
        removeNodeToItem(el.children, value, type);
      }
    }
  }
}

/**
 * 生成菜单树数据
 * @param {*} data  数据
 * @param {*} fid
 * @param {*} type
 */
export function creatMenuTreeJson(data, fid, type) {
  let arr = [];
  for (let i = 0; i < data.length; i++) {
    if (data[i].parentId == fid) {
      let item = {};
      item = data[i];
      item.label =
        item.pagePath.length > 0 ?
        item.name + "(" + item.pagePath + ")" :
        item.name;
      item.path = item.pagePath;
      item.children = creatMenuTreeJson(data, data[i][type], type);
      arr.push(item);
    }
  }
  return arr;
}

/**
 * 生成树数据 可以继承操作
 * @param {*} data  数据
 * @param {*} fid
 */
let canChildrenAccessible = [];
let noCanChildrenAccessible = [];
export function creatTreeJsonForInherit(data, fid) {
  let arr = [];
  for (let i = 0; i < data.length; i++) {
    if (data[i].parentId == fid) {
      let item = {};
      item = data[i];
      let can = false;
      let canIndex = canChildrenAccessible.find((n) => n == data[i].parentId);
      let noCanIndex = noCanChildrenAccessible.find(
        (n) => n == data[i].parentId
      );
      if (canIndex) {
        item.add = true;
        item.del = true;
        can = true;
      }

      if (noCanIndex && item.childrenAccessible == -1) {
        item.add = false;
        item.del = false;
        can = false;
      }

      if (item.childrenAccessible == 1) {
        canChildrenAccessible.push(data[i].id);
      } else if (item.childrenAccessible == 0) {
        noCanChildrenAccessible.push(data[i].id);
      } else {
        if (can == true) {
          canChildrenAccessible.push(data[i].id);
        } else {
          noCanChildrenAccessible.push(data[i].id);
        }
      }

      item.children = creatTreeJsonForInherit(data, item.id);
      arr.push(item);
    }
  }
  return arr;
}

/**
 *
 * @param {*} 获取x轴
 * @param {*}
 */
export function getxData() {
  let timex = [];
  let newtime = new Date().getTime();
  let newyear = formatDate(new Date(newtime), "yyyy");
  let lastyear = newyear - 1;
  let yearx = [String(lastyear), newyear];
  let newmouth = formatDate(new Date(newtime), "MM");
  let mouthx = [];
  let newTime = formatDate((new Date().setMonth(new Date().getMonth())), 'MM-') + '01'
  mouthx.push(getMouth_(formatDate(new Date(newTime).setMonth(new Date(newTime).getMonth() - 4), 'MM') + '-01'))
  newTime = formatDate((new Date().setMonth(new Date().getMonth())), 'MM-') + '01'
  mouthx.push(getMouth_(formatDate(new Date(newTime).setMonth(new Date(newTime).getMonth() - 3), 'MM') + '-01'))
  newTime = formatDate((new Date().setMonth(new Date().getMonth())), 'MM-') + '01'
  mouthx.push(getMouth_(formatDate(new Date(newTime).setMonth(new Date(newTime).getMonth() - 2), 'MM') + '-01'))
  newTime = formatDate((new Date().setMonth(new Date().getMonth())), 'MM-') + '01'
  mouthx.push(getMouth_(formatDate(new Date(newTime).setMonth(new Date(newTime).getMonth() - 1), 'MM') + '-01'))
  newTime = formatDate((new Date().setMonth(new Date().getMonth())), 'MM-') + '01'
  mouthx.push(getMouth_(formatDate(new Date(newTime).setMonth(new Date(newTime).getMonth()), 'MM') + '-01'))
  //   for (let i = 1; i < 5; i++) {
  //     let item = new Date().setMonth(new Date().getMonth(newTime) +i);
  //     mouthx.push(getMouth_(formatDate(new Date(item), "MM")));
  //     // console.log(formatDate(new Date(item), "MM"))
  //     // console.log(new Date().getMonth() - (4 - i))
  //   }
  let weekx = [];
  //   for (let i = 0; i < 6; i++) {
  for (let i = 0; i < 5; i++) {
    let item = new Date().getTime() - 7 * (4 - i - 2) * 3600 * 24 * 1000;
    weekx.push(getWeek_(formatDate(new Date(item), "yyyy-MM-dd")));
  }
  let dayx = [];
  for (let i = 0; i < 7; i++) {
    let item = new Date().getTime() - (6 - i) * 3600 * 24 * 1000;
    dayx.push(formatDate(new Date(item), "MM.dd"));
  }
  timex = [...yearx, ...mouthx, ...weekx, ...dayx];
  return timex;
}

/**
 *
 * @param {*} 获取周
 * @param {*} dt
 */
export function getWeek_(dt) {
  let d1 = new Date(dt);
  let d2 = new Date(dt);
  d2.setMonth(0);
  d2.setDate(1);
  let rq = d1 - d2;
  let days = Math.ceil(rq / (24 * 60 * 60 * 1000));
  let num = Math.ceil(days / 7) - 1;
  return "w" + num;
}

/**
 *
 * @param {*} _arr
 * @param {*} data  时间 月
 */
export function getMouth_(date) {
  let week;
  switch (date) {
    case "01-01":
      week = "Jan";
      break;
    case "02-01":
      week = "Feb";
      break;
    case "03-01":
      week = "Mar";
      break;
    case "04-01":
      week = "Apr";
      break;
    case "05-01":
      week = "May";
      break;
    case "06-01":
      week = "Jun";
      break;
    case "07-01":
      week = "Jul";
      break;
    case "08-01":
      week = "Aug";
      break;
    case "09-01":
      week = "Sep";
      break;
    case "10-01":
      week = "Oct";
      break;
    case "11-01":
      week = "Nov";
      break;
    case "12-01":
      week = "Dec";
      break;
    default:
      return "";
  }
  return week;
}
/**
 * 获取当前日、周、月、年开始时间
 * @param {*} type 时间类型
 */
export function getCurrStartTime(type) {
  let time;
  if (type == "day") {
    time =
      formatDate(new Date(new Date().getTime()), "yyyy-MM-dd") + " 00:00:00";
  } else if (type == "month") {
    time =
      formatDate(new Date(new Date().getTime()), "yyyy-MM") + "-01 00:00:00";
  } else if (type == "week") {
    let day = new Date().getDay() || 7;
    time = formatDate(new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate() + 1 - day))
  } else {
    time =
      formatDate(new Date(new Date().getTime()), "yyyy") + "-01-01 00:00:00";
  }
  return time;
}
/**
 *  获取当前日、周、月、年结束时间
 * @param {*} type 时间类型
 */
export function getCurrEndTime(type) {
  let time;
  if (type == "day") {
    time =
      formatDate(
        new Date(new Date().getTime() + 24 * 60 * 60 * 1000),
        "yyyy-MM-dd"
      ) + " 00:00:00";
  } else if (type == "month") {
    let item = new Date();
    item.setDate(1);
    item.setMonth(new Date().getMonth() + 1);
    time = formatDate(new Date(item), "yyyy-MM") + "-01 00:00:00";
  } else if (type == "week") {
    let day = new Date().getDay() || 7;
    time = formatDate(new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate() + 8 - day));
  } else {
    time =
      String(Number(formatDate(new Date(new Date().getTime()), "yyyy")) + 1) +
      "-01-01 00:00:00";
  }
  return time;
}
/**
 * 获取环期时间，昨日，上周，昨月，去年
 * @param {*} checktime 查询的开始时间
 * @param {*} timetype 日、月、年
 */
export function getCheckRepeatTime(checktime, timetype) {
  if (typeof (checktime) == "string") {
    let newStart = checktime
    checktime = newStart;
  }
  let newtiem = {};
  if (timetype == "day") {
    newtiem.fromDate =
      formatDate(
        new Date(new Date(checktime).getTime() - 24 * 60 * 60 * 1000),
        "yyyy/MM/dd"
      ) + " 00:00:00";
  } else if (timetype == "month") {
    let item = new Date(checktime).setMonth(new Date(checktime).getMonth() - 1);
    let time = formatDate(new Date(item), "yyyy/MM") + "/01 00:00:00";
    newtiem.fromDate = time;
  } else if (timetype == "week") {
    var now = new Date(checktime); //当前日期
    var nowDayOfWeek = now.getDay(); //今天本周的第几天
    var nowDay = now.getDate(); //当前日
    var nowMonth = now.getMonth(); //当前月
    var nowYear = now.getYear(); //当前年
    nowYear += (nowYear < 2000) ? 1900 : 0; //
    newtiem.fromDate = formatDate(new Date(nowYear, nowMonth, nowDay - nowDayOfWeek - 6), "yyyy/MM/dd") + " 00:00:00";
    checktime = formatDate(new Date(nowYear, nowMonth, nowDay - nowDayOfWeek + 1), "yyyy/MM/dd") + " 00:00:00";
  } else {
    let time =
      String(
        Number(formatDate(new Date(new Date(checktime).getTime()), "yyyy")) - 1
      ) + "-01-01 00:00:00";
    newtiem.fromDate = time;
  }
  newtiem.toDate = checktime;
  return newtiem;
}
/**
 * 获取同期时间 去年的今天、去年的今月
 * @param {*} checktime_form //传入的开始时间
 * @param {*} checktime_to //传入的结束时间
 * @param {*} timetype //时间类型
 */
export function getCheckBeforeTime(checktime_form, checktime_to, timetype) {
  //获取同期时间，昨日，昨月，去年
  let newtiem = {};
  if (typeof (checktime_form) == "string") {
    let newStart = checktime_form
    checktime_form = newStart;
  }
  if (typeof (checktime_to) == "string") {
    let newEnd = checktime_to
    checktime_to = newEnd;
  }
  let item = new Date(checktime_form).setFullYear(
    new Date(checktime_form).getFullYear() - 1
  );
  let item_to = new Date(checktime_to).setFullYear(
    new Date(checktime_to).getFullYear() - 1
  );
  let time_from = "",
    time_to = "";
  if (timetype == "day") {
    time_from = formatDate(new Date(item), "yyyy/MM/dd") + " 00:00:00";
    time_to = formatDate(new Date(item_to), "yyyy/MM/dd") + " 00:00:00";
  } else if (timetype == "month") {
    time_from = formatDate(new Date(item), "yyyy/MM") + "/01 00:00:00";
    time_to = formatDate(new Date(item_to), "yyyy/MM") + "/01 00:00:00";
  } else {
    time_from = formatDate(new Date(item), "yyyy") + "/01/01 00:00:00";
    time_to = formatDate(new Date(item_to), "yyyy") + "/01/01 00:00:00";
  }
  newtiem.fromDate = time_from;
  newtiem.toDate = time_to;
  return newtiem;
}

/**
 * 删除数组中的某一个对象
 * @param {*} _arr 数组
 * @param {*} _obj 需删除的对象
 */
export function removeAaary(_arr, _obj) {
  var length = _arr.length;
  for (var i = 0; i < length; i++) {
    if (_arr[i] == _obj) {
      if (i == 0) {
        _arr.shift(); //删除并返回数组的第一个元素
        return _arr;
      } else if (i == length - 1) {
        _arr.pop(); //删除并返回数组的最后一个元素
        return _arr;
      } else {
        _arr.splice(i, 1); //删除下标为i的元素
        return _arr;
      }
    }
  }
}
/**
 * [isDuringDate 比较当前时间是否在指定时间段内]
 * @author dongsir
 * @param    nowDateStr [传入时间]
 * @param    eginDateStr [开始时间]
 * @param    ndDateStr   [结束时间]
 * @return   Boolean
 */
export function isDuringDate(nowDateStr, beginDateStr, endDateStr) {
  if (typeof (nowDateStr) == "string") {
    let newStart = nowDateStr
    nowDateStr = newStart;
  }
  if (typeof (beginDateStr) == "string") {
    let newEnd = beginDateStr
    beginDateStr = newEnd;
  }
  if (typeof (endDateStr) == "string") {
    let newEnd = endDateStr
    endDateStr = newEnd;
  }
  var curDate = new Date(nowDateStr),
    beginDate = new Date(beginDateStr),
    endDate = new Date(endDateStr);
  if (curDate >= beginDate && curDate <= endDate) {
    return true;
  }
  return false;
}
//判断是否为数字
export function isNumber(obj) {
  return typeof obj === "number" && !isNaN(obj);
}
//判断是否为数字且不为空
export function isRealNum(val) {
  if (val === "" || val == null) {
    return false;
  }
  if (!isNaN(val)) {
    return true;
  } else {
    return false;
  }
}

export function getMain(obj) {
  if (obj.children.length > 0) {
    let item = getMain(obj.children[0]);
    return item;
  } else {
    return obj;
  }
}

/**
 * 递归获取部门的名称
 * @param {*} pid
 * @param {*} orsData
 */
export function getMountedOnName(pid, orsData) {
  let str = "";
  let item = orsData.find((obj) => obj.id == pid);
  if (item) {
    str += "/" + item.name;
    str += getMountedOnName(item.parentId, orsData);
  }
  return str;
}

/**
 * 逆向递归出页面名称
 * @param {*} pageId
 * @param {*} data
 */
export function getStrForPageId(pageId, data) {
  let str = "";
  let item = data.find((obj) => obj.pageId == pageId);
  if (item) {
    str += item.name;
    str += getStrForId(item.parentId, data);
  }
  return str;
}

export function getStrForId(id, data) {
  let str = "";
  let item = data.find((obj) => obj.id == id);
  if (item) {
    str += "/" + item.name;
    str += getStrForId(item.parentId, data);
  }
  return str;
}

/**
 * 判断是不是数字
 * @param {*} pid
 * @param {*} orsData
 */
export function isNumberForStr(val) {
  var regPos = /^\d+(\.\d+)?$/; //非负浮点数
  var regNeg = /^(-(([0-9]+\.[0-9]*[1-9][0-9]*)|([0-9]*[1-9][0-9]*\.[0-9]+)|([0-9]*[1-9][0-9]*)))$/; //负浮点数
  if (regPos.test(val) || regNeg.test(val)) {
    return true;
  } else {
    return false;
  }
}

/**
 * [获取URL中的参数名及参数值的集合]
 * 示例URL:http://htmlJsTest/getrequest.html?uid=admin&rid=1&fid=2&name=小明
 * @param {[string]} urlStr [当该参数不为空的时候，则解析该url中的参数集合]
 * @return {[string]}       [参数集合]
 */
export function getRequest(urlStr) {
  if (typeof urlStr == "undefined") {
    var url = decodeURI(location.search); //获取url中"?"符后的字符串
  } else {
    var url = "?" + urlStr.split("?")[1];
  }
  var theRequest = new Object();
  if (url.indexOf("?") != -1) {
    var str = url.substr(1);
    var strs = [];
    strs = str.split("&");
    for (var i = 0; i < strs.length; i++) {
      theRequest[strs[i].split("=")[0]] = decodeURI(strs[i].split("=")[1]);
    }
  }
  return theRequest;
}

//深拷贝
/**
 * [获取URL中的参数名及参数值的集合]
 * 示例URL:http://htmlJsTest/getrequest.html?uid=admin&rid=1&fid=2&name=小明
 * @param {[string]} obj
 */
export function deepClone(obj) {
  let result = Array.isArray(obj) ? [] : {};
  if (obj && typeof obj === "object") {
    for (let key in obj) {
      if (obj.hasOwnProperty(key)) {
        if (obj[key] && typeof obj[key] === "object") {
          result[key] = this.deepClone(obj[key]);
        } else {
          result[key] = obj[key];
        }
      }
    }
  }
  return result;
}

/**
 * base64转Blob函数
 * @param {string} b64Data
 * @param {string} contentType
 * @param {number} sliceSize
 */
export function b64toBlob(b64Data, contentType, sliceSize) {
  contentType = contentType || "";
  sliceSize = sliceSize || 512;

  var byteCharacters = atob(b64Data);
  var byteArrays = [];

  for (var offset = 0; offset < byteCharacters.length; offset += sliceSize) {
    var slice = byteCharacters.slice(offset, offset + sliceSize);

    var byteNumbers = new Array(slice.length);
    for (var i = 0; i < slice.length; i++) {
      byteNumbers[i] = slice.charCodeAt(i);
    }

    var byteArray = new Uint8Array(byteNumbers);

    byteArrays.push(byteArray);
  }

  var blob = new Blob(byteArrays, {
    type: contentType,
  });
  return blob;
}

/**
 * 将"2018-05-19T08:04:52.000+0000"这种格式的时间转化为正常格式
 * @param time
 */
export function timeFormat(time) {
  var d = new Date(time);

  var year = d.getFullYear(); //年
  var month = d.getMonth() + 1; //月
  var day = d.getDate(); //日

  var hh = d.getHours(); //时
  var mm = d.getMinutes(); //分
  var ss = d.getSeconds(); //秒

  var clock = year + "/";

  if (month < 10) clock += "0";

  clock += month + "/";

  if (day < 10) clock += "0";

  clock += day + " ";

  if (hh < 10) clock += "0";

  clock += hh + ":";
  if (mm < 10) clock += "0";
  clock += mm + ":";

  if (ss < 10) clock += "0";
  clock += ss;
  return clock;
}